import { Component, OnInit } from '@angular/core';
import { LoginService } from '../../login-service';

@Component({
    selector: 'initiatordashboard-app',
    templateUrl: 'initiatordashboard.component.html',
    providers:[LoginService]
})

export class InitiatorDashboardComponent implements OnInit {
    viewDetails: boolean=false;
    displayInvoice: boolean=false;
    displayview:boolean=false;
    usersList: any;
    collabos:any=[];
    invoiceList: any;
    userTypeName: string;
    collaboList: any;
    amount1:any=0;
    filteredcollaboList: any=[];
    currentcollabo: any;
    viewCollaborators: boolean=false;
    tempProposalBids: any;
    collaboBids: any=[];
    actorsList: any;
    actors: any=[];
    biduser: any;
    tempuser=[];
    url:string;
    collaboname: any;
    invoices: any;
    userinfo: any;
    invoicedetails: any;
    totalamount: number;
    approved:boolean=false;
    paid:boolean=false;
    invoicePayments=[];
    displaycollabos:boolean=false;
    SelectedstartDate=new Date();
    SelectedendDate=new Date();
    userID: string;
    myCollabos: any;
    presentprojects: any;
    proposalbidslist: any;
    paymentsList: any;
    skillsList: any;
    filteredskillsList: any;
    skillsList2: any;
    filteredskillsList2: any=[];
    filteredSkillsnameList: any=[];
    collaboamount: any=[];
    colamount: any;
  collabodetails: any;
    constructor(private loginService:LoginService) {
        this.userTypeName=localStorage.getItem('userType');
        this.userID=localStorage.getItem('USERID');
   
     }

    ngOnInit() {
        this.GetCollabos();
        this.GetUsers();
        this.GetInvoices();
     }
     GetCollabos(){
        this.loginService.GetCollabos(this.userTypeName).subscribe(data=>
            {
              data = JSON.parse(data['_body']);
                    this.collaboList=JSON.parse(JSON.stringify(data));
                  
                    this.myCollabos=this.collaboList.filter(x=>x.userid==this.userID);
                    
            })
     }
     
    GetUsers(){
        this.loginService.GetUsers(this.userTypeName).subscribe(data=>
          {

            data = JSON.parse(data['_body']);
                  this.usersList=JSON.parse(JSON.stringify(data));
                 
          })
        }

        GetInvoices(){
            this.loginService.GetInvoices().subscribe(data=>
              {
                data = JSON.parse(data['_body']);
                      this.invoiceList=JSON.parse(JSON.stringify(data));
                      
              })
              this.loginService.GetInvoicePayments().subscribe(data=>
                {
                  data = JSON.parse(data['_body']);
                        this.paymentsList=JSON.parse(JSON.stringify(data));
                     
                })
            }
            viewdetails(d)
            {
              this.collabodetails=d;
              this.displayview=true;
            }
            backtoCollabos(){
              this.displayview=false;
            }
     CompareDate(){
      this.collabos=[];
      this.amount1=0;
         if(this.SelectedstartDate>this.SelectedendDate)
         {
             this.displaycollabos=true;
             return;
         }
         else
         {
        
        
            this.loginService.GetCollabos(this.userTypeName).subscribe(data=>
                {
                  data = JSON.parse(data['_body']);
                        this.collaboList=JSON.parse(JSON.stringify(data));
                      
                        this.GetInvoices();
                        for(var i=0;i<this.invoiceList.length;i++){
                            let filterInvoices=this.collaboList.filter(x=>x.id==this.invoiceList[i].collaboid && x.userid==this.userID);
                            if(filterInvoices.length>0){
                                this.filteredcollaboList.push(filterInvoices);
                            }
                   else{
                    
                   }
                        }
                        for(let i=0;i<this.filteredcollaboList.length;i++)
                        {
                        if(this.filteredcollaboList[i][0].start_date.split("T")[0]>=this.SelectedstartDate&&this.filteredcollaboList[i][0].end_date.split("T")[0]<=this.SelectedendDate)
                        {
                          this.collabos.push(this.filteredcollaboList[i][0]);
                        
                         

                        }
                      }
                      var filterArray = this.collabos.reduce((accumalator, current) => {
                        if(!accumalator.some(item => item.id === current.id )) {
                          accumalator.push(current);
                        }
                        return accumalator;
                    },[]);
                    this.collabos=filterArray;
                    for(i=0;i<this.collabos.length;i++)
                    {
                      this.collabos[i].expected_budget=Number(this.collabos[i].expected_budget)
                      this.amount1=this.amount1+this.collabos[i].expected_budget;
                    }
                })
            }
            
              
    }
       
}
